module.exports = __webpack_public_path__ + "static/media/anchor.509b651d.svg";